'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var GlobalConst = require('../../types/GlobalConst');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var SelectComp = require('../common/SelectComp');


/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-29
 @Descript : 下拉列表框组件
 */
var ComboBoxBase = React.createClass({
  render: function () {
    //var selectedValue = this.props.items[this.props.selectedIndex].text || 0;

    var backColor = this.props.backgroundColor || '#fff';
    var borderColor = this.props.borderColor || '#444';
    var borderVisible = this.props.borderVisible;

    var width = parseInt(this.props.width, 10);
    var height = parseInt(this.props.height, 10);

    var compBox = {
      fontWeight: this.props.fontWeight,
      color: this.props.color,
      fontSize: this.props.fontSize,
      fontFamily: this.props.fontFamily,
      fontStyle: this.props.fontStyle,
      textDecoration: this.props.textDecoration,
    };

    var selectBox = {
      position: 'absolute',
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      border: borderVisible ? '1px solid ' + borderColor : 'none',

      lineHeight: height + 'px',
      backgroundColor: backColor,
    };

    var textBox = {
      position: 'absolute',
      left: 0,
      right: 24,
      height: '100%',
      padding: '0 5px',
      overflow: 'hidden'
    };

    var rightBtnBox = {
      position: 'absolute',
      height: '100%',
      width: 24,
      top: 0,
      right: 0,
      borderLeft: borderVisible ? '1px solid ' + borderColor : 'none',
    };

    var arrowStyle = {
      borderStyle: 'solid',
      borderWidth: '4px 4px 0px 4px',
      borderColor: 'black transparent transparent transparent',
      width: 0,
      height: 0,

      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      margin: 'auto'
    };

    return (
      <div
        key="select"
        ref="comboBox"
        style={compBox}>
        <div style={selectBox} onClick={this.toggleSelectExpand}>
          <div style={textBox}>
            <label>{this.state.value}</label>
          </div>
          <div style={rightBtnBox}>
            <div style={arrowStyle} />
          </div>
        </div>

      {/*<div ref="combobox"*/}
           {/*style={{*/}
             {/*width: '100%',*/}
             {/*height: '100%',*/}
             {/*left: 0,*/}
             {/*top: 0,*/}
             {/*position: 'absolute',*/}
             {/*border: 'none',*/}
             {/*//pointerEvents: 'none',*/}
             {/*zIndex: 10,*/}
             {/*textDecoration: 'inherit'*/}
           {/*}}*/}
           {/*onClick={this.toggleSelectExpand}*/}
      {/*>*/}
        {/*<canvas style={{width: '100%', height: '100%'}} ref="ctx"/>*/}
        {/*<div ref="txt" style={{*/}
          {/*position: 'absolute',*/}
          {/*height: '100%',*/}
          {/*top: 0,*/}
          {/*left: 5,*/}
          {/*right: 28,*/}
          {/*bottom: 0,*/}
          {/*textDecoration: 'inherit',*/}
          {/*fontWeight: this.props.fontWeight,*/}
          {/*color: this.props.color,*/}
          {/*fontSize: this.props.fontSize,*/}
          {/*fontFamily: this.props.fontFamily,*/}
          {/*fontStyle: this.props.fontStyle,*/}
          {/*whiteSpace: 'nowrap',*/}
          {/*overflow: 'hidden'*/}
        {/*}}>*/}
          {/*<div style={textBoxStyle} ref="back">*/}
            {/*<label>{this.state.value}</label>*/}
          {/*</div>*/}
        {/*</div>*/}
      {/*</div>*/}
      {
        this.props.canInput &&
        <input ref="input"
               style={{
          right: 26,
          bottom: 1,
          left: 1,
          top: 1,
          width: this.props.width - 30,
          position: 'absolute',
          zIndex: 20,
          borderStyle: 'none',
          borderColor: GlobalConst.GLOBAL_COLOR.TRANSPARENT_COLOR,
          backgroundColor: this.props.backgroundColor,
          textDecoration: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          fontSize: 'inherit',
          fontFamily: 'inherit',
          fontStyle: 'inherit',
          outline: 'none',
          textIndent: 5
        }}
               //onInput={this._onInput}
        />
      }
    </div>);
  },

  componentDidMount: function () {
    this.doSelect(this.props.selectedIndex || 0);
    // this.doPaint();
    $(ReactDOM.findDOMNode(this.refs.combobox)).css({lineHeight: ReactDOM.findDOMNode(this).getBoundingClientRect().height + 'px'});
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PAINT, this.onPaint);
    $(ReactDOM.findDOMNode(this)).bind('toggleExpand', this.toggleSelectExpand);
  },

  componentDidUpdate: function () {
    // this.doPaint();
  },

  toggleSelectExpand: function () {
    //this.setState({isExpand: true});
    var textPadding = parseInt(this.props.listControl.textPadding, 10) || 10;
    var textStyle = {
      width: parseInt(this.props.width, 10) - textPadding * 2,
      fontWeight: this.props.fontWeight,
      marginLeft: textPadding,
      fontSize: this.props.fontSize + 'px',
      fontFamily: this.props.fontFamily,
      fontStyle: this.props.fontStyle,
      textDecoration: this.props.textDecoration,
      lineHeight: this.props.height + 'px',
    };
    var listStyle = {
      selectedColor: this.props.listControl.selectedColor,
      selectedTextColor: this.props.listControl.selectedTextColor || '#000000',
      verticalScrollbarShow: this.props.listControl.verticalScrollbarShow,
      verticalScrollbarProgress: this.props.listControl.verticalScrollbarProgress
    };

    var boxStyle = {
      opacity: this.props.listControl.opacity,
    };
    if(this.props.borderVisible) {
      boxStyle.border = '1px solid ' + this.props.borderColor;
    }
    var props = {
      checkedIndex: this.state.checkedIndex,
      selectListItem: this.selectListItem,
      width: this.props.width,
      itemHeight: this.props.height,
      textStyle: textStyle,
      boxStyle: boxStyle,
      listStyle: listStyle,
      dataSet: this.items || this.props.items,
      id: ReactDOM.findDOMNode(this).getAttribute('data-reactid')
    };
    if(this.props.triggerSelectExpand) {
      this.props.triggerSelectExpand(ReactDOM.findDOMNode(this), props);
    }
  },

  selectListItem: function (e, index) {
    this.doSelect(index);
    if (this.props.onItemClick) {
      this.props.onItemClick(e, index);
    }
  },

  doPaint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.ctx);

    var g = canvas.getContext('2d');
    var w = canvas.clientWidth;
    var h = canvas.clientHeight;
    var iconH = 4;
    var iconW = 8;
    var btnW = 24;
    var thickness = 1;
    var t;
    canvas.width = w;
    canvas.height = h;

    g.clearRect(0, 0, w, h);
    g.fillStyle = this.props.backgroundColor || '#fff';
    g.strokeStyle = this.props.borderColor || '#444';
    g.lineWidth = 1;
    if (this.props.borderVisible) {
      g.beginPath();
      g.rect(thickness / 2, thickness / 2, w - thickness, h - thickness);
      g.closePath();
      g.fill();
      g.stroke();
    }
    if (this.props.backgroundColor) {
      g.fillStyle = this.props.backgroundColor;
      g.beginPath();
      g.rect(thickness, thickness, w - thickness * 2, h - thickness * 2);
      g.closePath();
      g.fill();
    }
    if (this.props.borderVisible) {
      g.beginPath();
      g.moveTo(w - btnW - thickness / 2, 0);
      g.lineTo(w - btnW - thickness / 2, h);
      g.closePath();
      g.stroke();
    }

    g.beginPath();
    g.fillStyle = '#444';// g.strokeStyle;

    t = Math.round((h - iconH) / 2);
    g.moveTo(w - btnW + (btnW - iconW) / 2 - thickness / 2, t);
    g.lineTo(w - (btnW - iconW) / 2 - thickness / 2, t);
    g.lineTo(w - btnW / 2 - thickness / 2, t + iconH);
    g.closePath();
    g.fill();

    $(ReactDOM.findDOMNode(this.refs.txt)).css({lineHeight: h + 'px'})
  },

  getInitialState: function () {
    var value = '';
    if(this.props.items && this.props.items[this.props.selectedIndex]) {
      value = this.props.items[this.props.selectedIndex].text || '';
    }
    return {
      value: value,
      isExpand: false,
      checkedIndex: 0,
      items: JSON.parse(JSON.stringify(this.props.items))
    };
  },

  onPaint: function () {
    this.doPaint();
  },

  doSelect: function (index) {
    var input;
    var items = this.items || this.state.items;

    var value;
    if(index >= 0) {
      value = items[index].text;
    } else {
      value = '';
    }
    if (this.props.canInput) {
      input = ReactDOM.findDOMNode(this.refs.input);
      input.value = value;
    }
    this.setState({value: value, checkedIndex: index, isExpand: false});
  },

  items: null,
  _onInput: function () {
    var input = ReactDOM.findDOMNode(this.refs.input);
    if (this.items === null) {
      this.items = JSON.parse(JSON.stringify(this.state.items));
    }
    this.items[this.state.checkedIndex].text = input.value;
    if (this.state.items) {
      this.setState({items: this.items});
    }
  }
});

module.exports = ComboBoxBase;



// WEBPACK FOOTER //
// ./src/views/common/ComboBoxBase.jsx